import styled from 'styled-components';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';
import { AlphaTheme } from '../../../../design-system/ThemeProvider/alphaTheme';

interface WrapperProps {
  isActive?: boolean;
  isCaMarket?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  background-color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.cardSurface ?? COLORS.white};
  display: flex;
  padding: 24px 16px 40px 16px;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  justify-content: space-between;
  gap: 10px;
  flex-grow: 1;
  @media ${device.laptop} {
    padding: 20px 20px 40px 20px;
    width: 366px;
    flex-grow: initial;
  }
`;

export const VehicleNameWrapper = styled.div`
  padding-bottom: 12px;
`;

export const Title = styled.h3`
  margin: 0;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral100 ?? COLORS.grey80};
  font-family: 'Audi Type';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.002px;
`;

export const TrimLineWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 4px;
`;

export const DescriptionWrapper = styled.div`
  margin-bottom: 8px;
  max-height: 126px;
  overflow-y: auto;
`;

export const ViewOfferCTA = styled.button`
  padding: 0;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral200 ?? COLORS.grey60};
  font-family: 'Audi Type';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.002px;
  cursor: pointer;
`;

export const InfoContainer = styled.div`
  width: 100%;
`;
